import { Box as MuiBox, BoxProps as MuiBoxProps } from "@mui/material";
import { ReactNode } from "react";

export default function asSpace(component: ReactNode, options?: MuiBoxProps) {
  return <MuiBox {...options}>{component}</MuiBox>;
}
